import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import classNames from 'classnames';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import { connect} from "react-redux";
import {showSuccessSnackbar, showErrorSnackbar} from '../store/actions/snackbarActions';
import  {postData } from '../ApiCalls/DataApis';
import {fetchOrganizations, fetchSelectedOrganization} from '../store/actions/organizationActions';
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import FiberManualRecordOutlinedIcon from '@material-ui/icons/FiberManualRecordOutlined';
import OrgPicEditor from '../components/OrgPicEditor';
import Amplify, { Auth } from 'aws-amplify';



const styles = theme => ({
  paper: {
    position: 'relative',
    // width: theme.spacing(120),
    width: theme.spacing(60),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0),
    borderRadius: '10px',
    // [theme.breakpoints.down('md')]:{
    //   width: theme.spacing(100),
    // },
    // [theme.breakpoints.down('sm')]:{
    //   width: theme.spacing(85),
    // },
    [theme.breakpoints.down('xs')]:{
      width: theme.spacing(43),
    }
  },
  contentCSS: {
    padding: '8px', 
    marginRight: '30px', 
    marginLeft: '30px',
    [theme.breakpoints.down('xs')]:{
      marginRight: '10px', 
      marginLeft: '10px',
    }
  },
  button: {
    // backgroundColor:'transparent',
    // borderRadius:'0px',
    width: '100%',
    height: '100%',
    border:'0px solid #4f86ce',
    justifyContent: 'flex-start',
    // display:'inline-block',
    // cursor:'pointer',
    // // color:'#4f87cc',
    fontFamily:'Trebuchet MS',
    fontSize:'12px',
    // // font-weight:bold;
    // padding:'5px 14px',
    // textDecoration:'none',
    // textShadow:'0px 0px 0px #9eb9ff',
    '&:hover': {
      backgroundColor:'transparent',
    },
    '&:active': {
      position:'relative',
      top:'1px',
      color:'#fafafa',
      
    },
  },
  buttonSuccess: {
    backgroundColor: green[500],
    color: '#fafafa',
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  dialog: {
    borderRadius: 10, 
    maxWidth: theme.spacing(150),
  },
  cardCSS: {
    width: '100%',
    borderRadius: '10px',
    // height: '750px',
    border:'1px solid #f5f5f5',
    padding: '8px',
    backgroundColor: '#fafafa',
    boxShadow: '2px 4px #f5f5f5',
    cursor:'pointer',
    '&:hover': {
      // backgroundColor:'#eeeeee',
      // boxShadow: '2px 4px #eeeeee',
      border:'1px solid #bdbdbd',
    },
    '&:active': {
      position:'relative',
      top:'1px',
      outline: 'none',
      // backgroundColor:'#eeeeee',
    },
    '&:focus': {
      outline: 'none',
      // backgroundColor:'#eeeeee',
      border:'1px solid #bdbdbd',
      boxShadow: '2px 4px #bdbdbd',
    },
  },
  cardCSSSelected: {
    width: '100%',
    borderRadius: '10px',
    // height: '750px',
    padding: '8px',
    outline: 'none',
    // backgroundColor:'#eeeeee',
    backgroundColor: '#fafafa',
    border:'1px solid rgb(51, 147, 242)',
    boxShadow: '1px 2px rgba(51, 147, 242,0.5)',
    position:'relative',
    cursor:'pointer',
    '&:active': {
      outline: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  headerCSS: {
    textAlign: 'center',
    color: '#1976d2',
    fontFamily:'Trebuchet MS',
    // marginTop: '20px',
    // marginBottom: '10px',
  },
  bodyCSS: {
    height: '20px',
    fontSize: '14px',
    color: 'rgb(84, 97, 128)',
    textAlign: 'center',
    fontFamily:'Trebuchet MS',
  },
  itemsCSS: {
    fontSize: '12px',
    color: '#525f7f',
    textAlign: 'left',
    fontFamily:'Trebuchet MS',
    listStyleType: 'none',
    marginTop: '15px',
    padding: '0px',
    height: '500px',
    // [theme.breakpoints.down('md')]:{
    //   height: '600px',
    // },
    // [theme.breakpoints.down('sm')]:{
    //   height: '750px',
    // },
    // [theme.breakpoints.down('xs')]:{
    //   width: theme.spacing(43),
    // },
  },
  itemsCSSRegular: {
    fontSize: '12px',
    color: '#525f7f',
    textAlign: 'left',
    fontFamily:'Trebuchet MS',
    listStyleType: 'none',
    marginTop: '15px',
    padding: '0px',
    height: '220px',
    // [theme.breakpoints.down('md')]:{
    //   height: '600px',
    // },
    [theme.breakpoints.down('sm')]:{
      height: '290px',
    },
    [theme.breakpoints.down('xs')]:{
      height: '220px',
    },
  },
  itemCSS: {
    padding: '5px',
  },
  subItemCSS: {
    fontSize: '11px',
    padding: '5px',
    paddingLeft: '25px',
  },
  checkmarkCSS: {
    fontSize: '14px',
    color:'rgb(0,209,0)',
  },
  circleCSS: {
    fontSize: '14px',
    color:'rgb(191, 191, 191)',
  },
  pricingCSS: {
    fontSize: '18px',
    fontWeight: 700,
    textAlign: 'center',
    fontFamily:'Trebuchet MS',
    marginTop: '16px',
    marginBottom: '16px',
  },
  deleteButton: {
    // backgroundColor: '#a41c4e',
    color: '#cd3d64',
  }
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

class AddFreeTrialOrganizationModal extends React.Component {
  constructor(props){
    super(props);
    this.state ={
      open: this.props.open,
      loading: false,
      success: false,
      organization_name: '',
      organization_description: '',

    }
    this.handleClose = this.handleClose.bind(this);
    this.submitButtonClick = this.submitButtonClick.bind(this);
    this.handleOrganizationNameChange = this.handleOrganizationNameChange.bind(this);
    this.handleOrganizationDescriptionChange = this.handleOrganizationDescriptionChange.bind(this);

  }
  

  handleClose = () => {
    this.setState(
      {
        open: false ,
        loading: false,
        success: false,
        organization_name: '',
        organization_description: '',
      });
    
    // Auth.signOut()
    // .then(() => { 
    //   this.setState(
    //     {
    //       open: false ,
    //       loading: false,
    //       success: false,
    //       organization_name: '',
    //       organization_description: '',
    //     }, () => {
    //       this.props.resetModalStates();
    //       window.location.reload()
            
    //   });
    // })
    // .catch(err => { 
    //   this.error(err); console.log('error is .......' + err)
    // });
  };


  handleOrganizationNameChange = (event) => {
    this.setState({organization_name: event.target.value});
  }

  handleOrganizationDescriptionChange = (event) => {
    this.setState({organization_description: event.target.value});
  }

  submitButtonClick = () => {
    
    const { loading } = this.state;
    if (!loading) {
     
      this.setState(
        {
          loading: true,
          success: false,
        },
        () => {
        postData('https://api.iotflows.com/v1/organizations/free-trial', 
        {'organization_name': this.state.organization_name,
          'organization_description': this.state.organization_description,
          'organization_is_private': true})
          .then(async response => {
            if(response.ok){
              this.props.showSuccessSnackbar("Free Trial Organization has been successfully added!");
              this.setState({
                loading: false,
                success: true,
                open:false,
              },() => { 
                this.handleClose();
                this.props.fetchOrganizations();
                this.props.resetModalStates(); 
              });
            }
            else{
              try{
                const data = await response.json();
                this.props.showErrorSnackbar(data.message);
                this.setState({
                  open:false,
                },() => { 
                  this.handleClose();
                  this.props.resetModalStates();
                });  
              }catch (e){
                this.props.showErrorSnackbar('Something went wrong');
              }
            }
          })
        })
    }
    
  };


  render() {
    const { classes, selectedOrganization, theme, currentUserInfo } = this.props;
    const { open, 
            loading, 
            success, 
            organization_name,
            organization_description } = this.state;

    const buttonClassname = classNames({
      [classes.buttonSuccess]: success,
    });


    return (
      <Grid
        container
        alignItems="center"
        justify="center"
        direction="column"
        
      >       

          
          <Dialog
              open={open}
              onClose={this.handleClose}
              TransitionComponent={Transition}
              keepMounted
              // onExited={this.handleClose}
              classes = {{paper: classes.dialog}}
            >
              <Paper className={classes.paper} >
                <DialogTitle style={{paddingBottom: '0px'}} >Add Free Trial Organization</DialogTitle>
                <DialogContent dividers className={classes.contentCSS} >
                
                

                {/* <div style={{justifyContent:'center', margin: '10px 0px 20px 0px', border:'0px solid rgb(255,255,255)'}}>
                  <OrgPicEditor organizationInfo={this.props.organizationInfo} orgPic={this.props.organizationInfo.organization_logo_url + String(Math.random())} />
                </div> */}


                <TextField
                  autoFocus
                  margin="normal"
                  id="organization_name"
                  label="Organization Name"
                  value={organization_name}
                  onChange={this.handleOrganizationNameChange}
                  type="text"
                  fullWidth
                />

                <TextField
                  margin="normal"
                  id="organization_description"
                  label="Organization Description"
                  value={organization_description}
                  onChange={this.handleOrganizationDescriptionChange}
                  type="text"
                  fullWidth
                />

                <ul style={{lineHeight: '30px', listStyleType: 'none', paddingLeft: '0px', color: '#3c4257', marginTop: '16px'}}>
                  <li style={{fontSize: '15px', fontWeight: 500}}>Free Trial Package</li>
                  <li style={{fontSize: '14px', paddingLeft: '8px', color:'#697386'}}> You’ll get $100 free trial credits for 2 months</li>
                </ul>

                </DialogContent>
                <DialogActions style={{justifyContent:'flex-end'}}>
                  <Button 
                    onClick={this.handleClose} 
                    // disabled={this.props.disableCancel} 
                    >
                    Log out
                  </Button>
                  <Button  color="primary" type='submit' className={buttonClassname} disabled={loading || organization_name =='' } onClick={this.submitButtonClick}>
                    Start Free Trial { loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                  </Button>
                </DialogActions>
              </Paper>
         
        </Dialog>

        
      </Grid>
    );
  }
}

AddFreeTrialOrganizationModal.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => ({
  showSuccessSnackbar: message => dispatch(showSuccessSnackbar(message)),
  showErrorSnackbar: message => dispatch(showErrorSnackbar(message)),
  fetchSelectedOrganization: currentOrganization => dispatch(fetchSelectedOrganization(currentOrganization)),
  fetchOrganizations: () => dispatch(fetchOrganizations()),

})

const mapStateToProps = state => {
  return {
    currentUserInfo: state.users.currentUserInfo,
    selectedOrganization: state.organizations.selectedOrganization
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(styles, {withTheme: true})(AddFreeTrialOrganizationModal));
